// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipeIngredientGroups_container__CU6sL","header":"RecipeIngredientGroups_header__Gbg5q","group":"RecipeIngredientGroups_group__Kffu2"};